import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// Rxjs
import { of, from } from 'rxjs';
import {
  switchMap,
  map,
  catchError,
  withLatestFrom,
  take,
  tap,
  delay,
  mergeMap,
  concatMap,
} from 'rxjs/operators';
// Store
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../app.state';
// Actions
import {
  loadTemplatesList,
  loadTemplatesListSuccess,
  loadTemplatesListFailure,
  getSelectedTemplate,
  getSelectedTemplateSuccess,
  getSelectedTemplateFailure,
  deleteTemplate,
  deleteTemplateSuccess,
  deleteTemplateFailure,
  addTemplate,
  addTemplateSuccess,
  addTemplateFailure,
  editTemplate,
  editTemplateFailure,
  editTemplateSuccess,
} from '../actions/template.actions';

// Models

// Selectors
import { setGetStatus } from '../selectors/form.selector';

// Services
import { TemplateService } from '../../services/template.service';

@Injectable()
export class TemplateEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private router: Router,
    private templateService: TemplateService,
    private toastAlert: ToastrService
  ) {}

  loadTemplatesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTemplatesList),
      //withLatestFrom(this.store.select(selectTemplate)),
      concatMap(({ formId }) =>
        this.templateService.getTemplates(formId).pipe(
          //tap((data:any) => {console.log('EFFECT loadTemplatesList->', data)}),
          map((data: any) => loadTemplatesListSuccess({ data: data })),
          catchError((error) => of(loadTemplatesListFailure({ error })))
        )
      )
    )
  );

  getSelectedTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getSelectedTemplate),
      concatMap(({ formId, template }) =>
        this.templateService.getTemplate(formId, template).pipe(
          map((data: any) => getSelectedTemplateSuccess({ template: data })),
          catchError((error) => of(getSelectedTemplateFailure({ error })))
        )
      )
    )
  );

  DeleteTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteTemplate),
      concatMap(({ formId, template }) =>
        this.templateService.deleteTemplate(formId, template).pipe(
          map(({ content }) =>
            deleteTemplateSuccess({ sk: template.sk, pk: template.pk })
          ),
          catchError((error) => of(deleteTemplateFailure({ error })))
        )
      )
    )
  );

  DeleteTemplateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteTemplateSuccess),
        tap((action) => {
          this.toastAlert.success(
            'Delete template was successful',
            'Delete Template'
          );
        })
      ),
    { dispatch: false }
  );

  AddTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addTemplate),
      concatMap(({ formId }) =>
        this.templateService.addTemplate(formId).pipe(
          map((data: any) => addTemplateSuccess({ template: data })),
          catchError((error) => of(addTemplateFailure({ error })))
        )
      )
    )
  );

  AddTemplateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addTemplateSuccess),
        tap((action) => {
          this.toastAlert.success(
            'Create template was successful',
            'Create Template'
          );
        })
      ),
    { dispatch: false }
  );

  EditTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editTemplate),
      concatMap(({ formId, template }) =>
        this.templateService.editTemplate(formId, template).pipe(
          map((data: any) => editTemplateSuccess({ template: data })),
          catchError((error) => of(editTemplateFailure({ error })))
        )
      )
    )
  );

  EditTemplateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editTemplateSuccess),
        tap((action) => {
          this.toastAlert.success('Edit template was successful', 'Edit Template');
        })
      ),
    { dispatch: false }
  );

  TemplatesError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          loadTemplatesListFailure,
          getSelectedTemplateFailure,
          deleteTemplateFailure,
          addTemplateFailure,
          editTemplateFailure
        ),
        tap(({ error }) => {
          const msgError = error.error || 'Internal Error ';
          this.toastAlert.error(msgError, 'Error');
        })
      ),
    { dispatch: false }
  );
}
